export default "__VITE_ASSET__DMckI2BC__"